module.exports = __webpack_public_path__ + "static/commuters-iphone-app-5e546dfd55c646f469ba20eddf8e0f98.png";